import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function KnowledgeBaseError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load knowledge base')}
      description={t('Something went wrong while loading this knowledge base. Please try again.')}
      loggerName='KnowledgeBaseError'
    />
  )
}
